export default __webpack_public_path__ + "static/media/Duplicate_Icon.5912e127.svg";